import React, { useState } from "react";
import { 
  FaUser, FaBook, FaSchool, FaCalendarAlt, 
  FaMosque, FaPrayingHands, FaQuestionCircle, 
  FaStar, FaChild, FaBlog, FaLandmark,
  FaBookReader,
  FaBookOpen,
  FaUsers,
  FaHome,
  FaQuoteRight,
  FaSignOutAlt
} from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";
import MenuModal from "./MenuModal";
import { AuthContext } from "../../context/Authcontext";
import { logout as logoutRequest, resetSessionFlag } from "../../utils/api";

const routeMap = {
  users: "admin/users",
  pandits: "admin/pandits",
  departments: "admin/departments",
  events: "admin/events",
  quizzes: "admin/quizzes",
  prayers: "admin/prayers",
  dailyprayers: "admin/dailyprayers",
  specialdays: "admin/specialdays",
  mandirs: "admin/mandirs",
  hindilearning: "admin/hindilearning",
  kinderhuis: "admin/kinderhuis",
  ebibliotheek: "admin/ebibliotheek",
  dharmalearning: "admin/dharmalearning",
  schools: "admin/schools",
  hoofdbestuur: "admin/hoofdbestuur",
  blogs: "admin/blogs",
  kyun: "admin/kyun",
  dailyquotes: "admin/dailyquotes",
};

const icons = {
  users: <FaUser />,
  pandits: <FaUsers />,
  departments: <FaBook />,
  events: <FaCalendarAlt />,
  quizzes: <FaQuestionCircle />,
  prayers: <FaPrayingHands />,
  dailyprayers: <FaPrayingHands />,
  specialdays: <FaStar />,
  mandirs: <FaMosque />,
  hindilearning: <FaBook />,
  kinderhuis: <FaChild />,
  ebibliotheek: <FaBookReader />,
  dharmalearning: <FaBookOpen />,
  schools: <FaSchool />,
  hoofdbestuur: <FaLandmark />,
  blogs: <FaBlog />,
  kyun: <FaQuestionCircle />,
  dailyquotes: <FaQuoteRight />,
};

const labels = {
  users: "Users",
  pandits: "Pandits",
  departments: "Departments",
  events: "Events",
  quizzes: "Quizzes",
  prayers: "Prayers",
  dailyprayers: "Daily Prayers",
  specialdays: "Special Days",
  mandirs: "Mandirs",
  hindilearning: "Hindi Learning",
  kinderhuis: "Kinderhuis",
  ebibliotheek: "E-Bibliotheek",
  dharmalearning: "Dharma Learning",
  schools: "Schools",
  hoofdbestuur: "Hoofdbestuur",
  blogs: "Blogs",
  kyun: "Kyun",
  dailyquotes: "Daily Quotes",
};

export default function Sidebar() {
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { user, logout } = React.useContext(AuthContext);
  
  if (!user) {
    return null;
  }

  const navigationItems = [
    { key: "dashboard", label: "Dashboard", icon: <FaHome />, path: "/dashboard" },
    ...Object.keys(routeMap).map((key) => ({
      key,
      label: labels[key],
      icon: icons[key],
      path: `/${routeMap[key]}`,
    })),
  ];

  const handleLogout = async () => {
    try {
      await logoutRequest();
    } catch (error) {
      console.error("Logout request failed:", error);
    } finally {
      resetSessionFlag();
      logout();
      navigate("/");
    }
  };

  return (
    <>
      <aside className="sidebar">
        <button className="brand-button" type="button" onClick={() => navigate("/dashboard") }>
          <img src="/logo.png" alt="Logo" className="logo" title="Dashboard" />
          <div className="brand-copy">
            <strong>MyDharma Admin</strong>
            <span>{user?.name || user?.email || "Admin session"}</span>
          </div>
        </button>

        <ul className="sidebar-nav">
          {navigationItems.map((item) => (
            <li
              key={item.key}
              title={item.label}
              className={location.pathname === item.path ? "active" : ""}
              onClick={() => navigate(item.path)}
            >
              {item.icon}
              <span className="label">{item.label}</span>
            </li>
          ))}
        </ul>

        <div className="sidebar-footer">
          <button className="expand-btn" onClick={() => setModalOpen(true)}>
            Full Menu
          </button>
          <button className="logout-btn" type="button" onClick={handleLogout}>
            <FaSignOutAlt />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {isModalOpen && (
        <MenuModal
          navigationItems={navigationItems}
          routeMap={routeMap}
          icons={icons}
          labels={labels}
          currentPath={location.pathname}
          onLogout={handleLogout}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
